import variantsStockController from './variantsStockController'

export default variantsStockController



// WEBPACK FOOTER //
// ../src/controllers/variantsStockController/index.js